@for (page of pages(); track $index) {
  <cfp-report-page
    [portfolioTitle]="customerName()"
    [translationKeyPrefix]="translationKeyPrefix()"
    [headerLogo]="headerLogo()"
    [chromeFooter]="chromeFooter()"
  >
    <h1>{{ customerName() }}</h1>
    @if ($index === 0) {
      <div class="row mb-5">
        <div class="col-6">
          <cfp-portfolio-business-case-card
            [title]="translationKey('summary') | translate"
            [portfolioId]="portfolioId()"
            [numberOfBuildings]="portfolioBuildingsRoadmap().businessCase.numberOfBuildings"
            [showArea]="true"
            [showPaybackPeriod]="false"
            [showInvestmentBeforeCostReduction]="true"
            [businessCase]="businessCase()"
            [investmentLabel]="translationKey('businessCase.investment')"
            [costReductionLabel]="translationKey('businessCase.costReduction')"
            [co2ConsumptionReductionLabel]="translationKey('businessCase.co2ConsumptionReduction')"
          />
        </div>
        <div class="col-6">
          <div class="card card-map">
            <div class="card-body">
              <cfp-portfolio-locations-map
                class="d-flex w-100 flex-column"
                [moduleRoute]="'/energy'"
                [portfolioId]="portfolioId()"
                [showHeader]="false"
              />
            </div>
          </div>
        </div>
      </div>
    }
    <h2>
      {{
        ('buildings' | translate) +
          ($index > 0 ? ' (' + (translationKey('continued') | translate) + ')' : '')
      }}
    </h2>
    <cfp-report-buildings-table
      [portfolioBuildingsRoadmapBuildings]="page"
    />
    <cfp-report-buildings-legend
      [portfolioBuildingsRoadmap]="portfolioBuildingsRoadmap()"
      [showPlan]="true"
    />
  </cfp-report-page>
}
